import moment from 'moment';

export default {
    filters: {
        formatDateTime(value) {
            if (value !== null) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss');
            }
            return 'unknown';
        },
        formatDateTimeMinutes(value) {
            if (value !== null && value !== '') {
                return moment(String(value)).format('DD/MM/YYYY HH:mm:ss');
            }
            return '-';
        },
        formatDate(value) {
            return moment(String(value)).format('DD/MM/YYYY');
        },
        formatTime(value) {
            return moment(String(value)).format('hh:mm:ss');
        },
    },
};
